export interface ActivityInfoVO {
  activityId: string;
  startTime: number;
  endTime: number;
  endTimeStr: string;
  activityImage: string;
  activityUrl: string;
  activityShareUrl: string;
  activityTerms: string;
}

export enum InviteActivityType {
  InvitePolity = 1,
  InvitePolityCode = 10,
}
